import { render } from "./Roles.vue?vue&type=template&id=75bc8d84&scoped=true"
import script from "./Roles.vue?vue&type=script&lang=js"
export * from "./Roles.vue?vue&type=script&lang=js"

import "./Roles.vue?vue&type=style&index=0&id=75bc8d84&scoped=true&lang=scss"
/* custom blocks */
import block0 from "@/locales/ru/common/permissions.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fapp%2Fsrc%2Fviews%2FRoles.vue&locale=ru"
if (typeof block0 === 'function') block0(script)
import block1 from "@/locales/en/common/permissions.json?vue&type=custom&index=1&blockType=i18n&issuerPath=%2Fapp%2Fsrc%2Fviews%2FRoles.vue&locale=en"
if (typeof block1 === 'function') block1(script)
import block2 from "@/locales/ru/views/roles.json?vue&type=custom&index=2&blockType=i18n&issuerPath=%2Fapp%2Fsrc%2Fviews%2FRoles.vue&locale=ru"
if (typeof block2 === 'function') block2(script)
import block3 from "@/locales/en/views/roles.json?vue&type=custom&index=3&blockType=i18n&issuerPath=%2Fapp%2Fsrc%2Fviews%2FRoles.vue&locale=en"
if (typeof block3 === 'function') block3(script)


import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75bc8d84"]])

export default __exports__